import React, { useEffect, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FavoriteContext } from "../../Store/Favoris_context";
import { PanierContext } from "../../Store/Panier_context";
import { AuthContext } from "../AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import {
  faHeart,
  faCartShopping,
  faArrowAltCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import VusProduct from "./VusProduct";
import API from "../Authentification/api";
import { getProductImage } from "../../Utils/Cloudinary";

const SearchProduct = () => {
  const [products, setProducts] = useState([]);
  const location = useLocation();

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [showPopUp, setshowPopUp] = useState(false);

  const closePopUp = () => {
    setSelectedProduct(null);
    setshowPopUp(false);
  };
  const openPopUp = (product) => {
    setSelectedProduct(product);
    setshowPopUp(true);
  };

  const navigate = useNavigate();

  const { addFavorite, removeFavorite, favorites } = useContext(FavoriteContext);
  const { addProductToCart } = useContext(PanierContext);
  const { isLoggedIn } = useContext(AuthContext);

  const formatPrice = (price) => {
    const numericValue = typeof price === 'string' ? parseFloat(price) : price;

    return new Intl.NumberFormat('fr-FR', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numericValue);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("query");

    const storedResults = localStorage.getItem("searchResults");
    if (storedResults) {
      setProducts(JSON.parse(storedResults));
      localStorage.removeItem("searchResults");
    } else if (query) {
      // Fallback API si pas dans le localStorage
      const fetchProducts = async () => {
        try {
          const res = await API.get(
            `/products/search?q=${encodeURIComponent(query)}`
          );
          const data = res.data?.data ?? [];
          setProducts(data);
        } catch (error) {
          if (process.env.NODE_ENV !== 'production') {
            console.error("Erreur fetchs produits recherche:", error);
          }

        }
      };

      fetchProducts();
    }
  }, [location.search]);

  const handleNavigation = () => {
    navigate("/all_products");
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <h1 className="col-sm-8 col-10 title mt-2 mt-md-0 text-capitalize">
          Résultats de la recherche
        </h1>
        <div className="col-sm-4 col-2 mt-2 mt-md-0">
          <div className="voir_tout">
            <div
              onClick={handleNavigation}
              className="row d-flex align-content-end"
              style={{
                textDecoration: "none",
                color: "#FA7F1B",
                cursor: "pointer",
              }}
            >
              <div className="col text-end d-none d-md-block">
                Voir tous les produits <FontAwesomeIcon icon={faArrowAltCircleRight} />
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr style={{ color: "#FA7F1B", height: "0.2rem" }} className="m-0" />
      {products.length > 0 ? (
        <div className="row mt-2">
          {products.map((prod) => {
            const toggleFavorite = (prod) => {
              const existing = favorites.find(
                (fav) => fav.product_id === prod.id
              );

              if (existing) {
                // Le produit est déjà dans les favoris → SUPPRESSION
                removeFavorite(existing.id);
              } else {
                // Le produit n'est pas favori → AJOUT
                addFavorite(prod.id);
              }
            };
            const isFavorite =
              favorites && favorites.some((fav) => fav.product_id === prod.id);

            const isUnavailable = prod.disponibility === "non";

            return (
              <div
                key={prod.id}
                className="col-md-3 col-sm-4 col-lg-2 col-6 mb-3 "
                data-tour={prod.id === 1 ? "product-card" : undefined}
              >
                <div className={`d-flex flex-column p-1 p-md-2 h-100 ${isUnavailable ? "nm-dispo-off" : ""}`}>
                  <img
                    src={getProductImage(prod.image)}
                    className="card-img-top img_product"
                    alt={prod.name}
                    onClick={() => openPopUp(prod)}
                    loading="lazy"
                  />
                  <div className="card-body px-0 pb-0 pt-1">
                    <h5
                      className="text-truncate petit_titre mb-1"
                      style={{ textTransform: "none" }}
                      title={prod.name}
                    >
                      {prod.name}
                    </h5>
                    <p className="card-text petit_titre fw-bold mb-1">
                      {formatPrice(prod.price.toLocaleString())} FCFA
                    </p>

                    {!isLoggedIn ? (
                      <div className="my-1">
                        <Button
                          className="border-0 w-100 btn-panier"
                          onClick={() => !isUnavailable && addProductToCart(prod)}
                          disabled={isUnavailable}
                          style={{
                            fontSize: "10px",
                            backgroundColor: isUnavailable ? "#adb5bd" : "#0066BD",
                          }}
                        >
                          <span className="d-inline">
                            {isUnavailable ? "Indisponible" : "Panier"}
                          </span>
                          {!isUnavailable && (
                            <FontAwesomeIcon className="" icon={faCartShopping} />
                          )}
                        </Button>


                      </div>
                    ) : (
                      <div className="d-flex flex-row justify-content-between align-items-center my-1">
                        <Button
                          className="border-0 btn-panier"
                          onClick={() => !isUnavailable && addProductToCart(prod)}
                          disabled={isUnavailable}
                          style={{
                            fontSize: "10px",
                            backgroundColor: isUnavailable ? "#adb5bd" : "#0066BD",
                          }}
                        >
                          <span className="d-inline">
                            {isUnavailable ? "Indisponible" : "Panier"}
                          </span>
                          {!isUnavailable && (
                            <FontAwesomeIcon className="" icon={faCartShopping} />
                          )}
                        </Button>
                        <FontAwesomeIcon
                          icon={faHeart}
                          onClick={() => toggleFavorite(prod)}
                          style={{
                            cursor: "pointer",
                            color: isFavorite ? "red" : "#FA7F1B",
                            transition: "0.2s",
                            fontSize: "14px"
                          }}
                        />
                      </div>
                    )}
                    {isUnavailable && (
                      <p className="nm-dispo-label mb-0">Non disponible</p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      ) : (
        <p>Aucun produit trouvé.</p>
      )}
      {showPopUp && (
        <VusProduct closePopUp={closePopUp} product={selectedProduct} />
      )}
    </div>
  );
};

export default SearchProduct;
